


















import { Component, Vue } from 'vue-property-decorator';
import Panel from '@/components/Panel.vue';
import { ContractService } from '@/services/ContractService';
import { StateManager } from '@/services/StateManager';
import { Loader } from '@/services/Loader.ts';
import * as Helper from '@/helpers/Utils.ts';

@Component({
  components: {
    Panel,
  },
  mounted() {
    Loader.GetInstance().LoadApp();
    ContractService.UpdateTotalSupply();
  },
})
export default class Generate extends Vue {
  private state = StateManager.GetInstance().GetState();

  get totalSupply() {
    return this.state.totalSupply / Math.pow(10, Helper.Utils.TOKEN_DECIMALS);
  }

  get supplyLimit() {
    return this.state.supplyLimit / Math.pow(10, Helper.Utils.TOKEN_DECIMALS);
  }

  public generateClicked() {
    ContractService.Generate();
  }
}
